import React, { useState, Suspense, lazy } from "react";
import "./App.css";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import MetaPixel from "./Pages/MetaPixel";
import stockData from "./data/stockData";
// ✅ Correct imports for icons
import { FaFacebookF, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

// lazy 
const Inventory = lazy(() => import("./Pages/Inventory"));
const ProductDetail = lazy(() => import("./Pages/ProductDetail"));
const CartPage = lazy(() => import("./Pages/CartPage"));
const Sidebar = lazy(() => import("./Pages/Sidebar"));
const About = lazy(() => import("./Pages/About"));
const Checkout = lazy(() => import("./Pages/Checkout"));
const TrackOrder = lazy(() => import("./Pages/TrackOrder"));




function App() {
  // side bar
  const [sidebarOpen, setSidebarOpen] = useState(false);
  // const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  const [cart, setCart] = useState([]);

  // Add to cart with size-specific duplicate check
  const handleAddToCart = (product, selectedSize) => {
    if (!selectedSize) {
      alert("Please select a size before adding to cart!");
      return;
    }

    const existingItem = cart.find(
      (item) => item.id === product.id && item.size === selectedSize
    );

    if (existingItem) {
      alert("This product with the selected size is already in your cart!");
      return;
    }

    const getPriceValue = (price) => {
      if (typeof price === "string") return parseFloat(price.replace("$", ""));
      return Number(price) || 0;
    };

    const newItem = {
      ...product,
      size: selectedSize,
      quantity: 1,
      price: getPriceValue(product.newPrice || product.price),
      img: product.imgs?.[0] || product.img || "",
    };

    setCart((prev) => [...prev, newItem]);
    // subtle success UX (you can replace with a toast)
    setTimeout(() => alert(`${product.name} (${selectedSize}) added to your cart!`), 80);
  };

  // Buy now: add single item and navigate (navigate is optional - some components pass it)
  const handleBuyNow = (product, navigate) => {
    const cartItem = { ...product, quantity: 1 };
    setCart([cartItem]);
    if (typeof navigate === "function") navigate("/cart");
    else window.location.href = "/cart";
  };

  // Remove item (id + size)
  const handleRemoveFromCart = (productId, size) => {
    setCart((prev) =>
      prev.filter((item) => !(item.id === productId && item.size === size))
    );
  };

  // Quantity change (id + size)
  const handleQuantityChange = (productId, size, newQuantity) => {
    setCart((prev) =>
      prev.map((item) =>
        item.id === productId && item.size === size
          ? { ...item, quantity: Math.max(1, newQuantity) }
          : item
      )
    );
  };

  const totalItems = cart.reduce((sum, item) => sum + item.quantity, 0);

  // categories and stockData (kept from your content)
  const categories = [
    { name: "Hoodies", img: "/Homepage/hoodies.webp", path: "/inventory/hoodies" },
    { name: "Jackets", img: "/Homepage/jackets.webp", path: "/inventory/jackets" },
    { name: "Track Suit", img: "/Homepage/tracksuit.webp", path: "/inventory/trackSuit" },
    { name: "Polo", img: "/Homepage/Polo.webp", path: "/inventory/polo" },
    { name: "Trousers", img: "/Homepage/trousers.webp", path: "/inventory/trousers" },
  ];

//  stock

return (
  <Router>
    <MetaPixel/>

    <div className="App">

      <header className="header glass-nav">
        <div className="left-section">
          <button className="menu-btn" aria-label="Menu" onClick={() => setSidebarOpen(true)}>
            <span className="menu-bar"></span>
            <span className="menu-bar"></span>
            <span className="menu-bar"></span>
          </button>

          <div className="logo">Gold Coast</div>
        </div>

        <nav>
          {/* <a href="#">🔍</a> */}
          <Link to="/cart" className="cart-icon">
            🛒 <span className="cart-badge">{totalItems}</span>
          </Link>
        </nav>
      </header>
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

<Suspense fallback={<div className="loader">Loading...</div>}>
      <Routes>
        <Route
          path="/"
          element={
            <>
              {/* HERO (full video background with center CTA) */}
              <section className="hero-section">
                <video className="hero-bg-video" autoPlay loop muted playsInline>
                  <source src="/Backgrounds/back12.mp4" type="video/mp4" />
                </video>

                <div className="hero-overlay" />

                <div className="hero-content">
                  <div className="hero-left">
                    <h1 className="brand-heading">
                      <span className="light">Welcome to</span><br />
                      <span className="gold-text">Gold Coast</span>
                    </h1>

                    {/* minimal CTA centered on hero */}
                    <div className="hero-cta">
                      <Link to="/inventory/hoodies" className="cta-btn">Shop Now</Link>
                    </div>
                  </div>
                </div>
              </section>

              {/* Categories */}
              <section className="categories-section">
                <h2 className="categories-heading">
                  Explore Our <span>Categories</span>
                </h2>

                <div className="scroll-categories">
                  {categories.map((cat, idx) => (
                    <Link key={idx} to={cat.path} className="category" aria-label={cat.name}>
                      <div
                        className="category-bg"
                        style={{ backgroundImage: `url(${cat.img})` }}
                      />
                      <div className="category-glow"></div>
                      <div className="category-label">
                        <span>{cat.name}</span>
                        <small>Explore the range</small>
                      </div>
                    </Link>
                  ))}
                </div>
              </section>


              {/* New Arrivals */}
              <section className="new-arrivals-section">
                <h2 className="new-arrivals-heading">
                  New <span>Arrivals</span>
                </h2>

                <div className="new-arrivals-scroll">
                  {stockData.NewArrivals.map((item, idx) => (
                    <Link
                      key={idx}
                      to={`/product/${item.id}`}
                      className="new-arrival-card"
                      aria-label={item.name}
                    >
                      <div className="img-wrapper">
                        <img
                          src={item.imgs[0]}
                          alt={item.name}
                          className="main-img"
                        />
                        {item.imgs[1] && (
                          <img
                            src={item.imgs[1]}
                            alt={`${item.name} alt`}
                            className="hover-img"
                          />
                        )}
                      </div>
                      <div className="new-arrival-info">
                        <h3>{item.name}</h3>
                        <p className="price-tag">Rs. {item.price}</p>
                      </div>
                    </Link>
                  ))}
                </div>
              </section>


              {/* Footer */}
              {/* Footer */}
 <footer className="footer">
      <div className="footer-grid">
        <div>
          <h4>Gold Coast</h4>
          <p>Luxury streetwear · Timeless style · Sustainable choices</p>
          <small>© {new Date().getFullYear()} Gold Coast — All rights reserved</small>
        </div>

        <div>
          <h5>Connect</h5>
          <ul className="social-links">
            <li>
              <a
                href="https://www.facebook.com/profile.php?id=61581823531750&mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaFacebookF /> Facebook
              </a>
            </li>
            <li>
              <a
                href="https://www.instagram.com/goldcoast_official?igsh=MXI0NHc0bW9ra3g0eQ%3D%3D&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram /> Instagram
              </a>
            </li>
            <li>
              <a href="https://wa.me/923281678437" target="_blank" rel="noopener noreferrer">
                <FaWhatsapp /> WhatsApp
              </a>
            </li>
            <li>
              <a href="mailto:sales@goldcoastpk.com">
                <MdEmail /> sales@goldcoastpk.com
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h5>Support</h5>
          <p>Need help or have a question?</p>
          <a href="mailto:sales@goldcoastpk.com" className="support-link">
            Contact Support
          </a>
        </div>
      </div>
    </footer>
            </>
          }
        />

        {/* Inventory / Product / Cart pages (pass handlers) */}
        <Route path="/inventory/:category" element={<Inventory stockData={stockData} />} />
        <Route
          path="/product/:id"
          element={
            <ProductDetail
              stockData={stockData}
              onAddToCart={handleAddToCart}
              onBuyNow={handleBuyNow}
            />
          }
        />
        <Route
          path="/cart"
          element={
            <CartPage
              cart={cart}
              onRemoveFromCart={handleRemoveFromCart}
              onQuantityChange={handleQuantityChange}
            />
          }
        />
        <Route path="/about" element={<About />} />
        <Route path="/checkout" element={<Checkout setCart={setCart} />} />

        <Route path="/track-order" element={<TrackOrder />} />
{/* <Route path="/contact" element={<Contact />} />  */}
      </Routes>
      </Suspense>
    </div>
  </Router>
);
}

export default App;